import { NORMAN } from '../../constants/WidgetColors';
const NOTIFICATION_BACKGROUND_COLOR = NORMAN;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getNotificationBackgroundColor = theme => NOTIFICATION_BACKGROUND_COLOR;